import React from 'react';
import PropTypes from 'prop-types';
import _debounce from 'lodash/debounce';
import { Form } from 'react-bootstrap';

import DeleteButtonWithModal from '../../DeleteButtonWithModal';

const ExistingTyperRow = ({ typer, onUpdate, onDelete }) => {
  const updateField = _debounce(async (e) => {
    await onUpdate(typer.id, e.target.getAttribute('field'), e.target.value);
  }, 300);

  return (
    <tr>
      <td>{typer.id}</td>
      <td>
        <Form.Control
          defaultValue={typer.name}
          field="name"
          onChange={updateField}
        />
      </td>
      <td>
        <Form.Control
          type="password"
          placeholder="Fill to change"
          field="password"
          onChange={updateField}
        />
      </td>
      <td>
        <Form.Check
          type="checkbox"
          defaultChecked={typer.enabled}
          field="enabled"
          onChange={(e) => onUpdate(typer.id, 'enabled', e.target.checked)}
        />
      </td>
      <td>{typer.template_items_count}</td>
      <td>
        <DeleteButtonWithModal
          text="Delete"
          modalTitle="Delete Typer"
          modalText="Are you sure you want to delete this typer?"
          onDelete={() => onDelete(typer.id)}
        />
      </td>
    </tr>
  );
};

ExistingTyperRow.propTypes = {
  typer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    enabled: PropTypes.number.isRequired,
    template_items_count: PropTypes.number.isRequired,
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ExistingTyperRow;
